import React from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, className = '', ...props }, ref) => {
    return (
      <div className="w-full">
        {label && (
          <label
            htmlFor={props.id || props.name}
            className="block text-xs font-semibold text-slate-700 dark:text-slate-400 tracking-wider uppercase mb-2"
          >
            {label}
          </label>
        )}
        <input
          ref={ref}
          className={`w-full text-sm border border-slate-200 dark:border-slate-800 rounded-lg px-3 py-2 bg-white/50 dark:bg-slate-900/50 hover:bg-slate-100 dark:hover:bg-slate-900 focus:bg-slate-100 dark:focus:bg-slate-900 dark:shadow-inner text-slate-700 dark:text-slate-300 placeholder:text-slate-500 focus:border-slate-200 dark:focus:border-slate-700 focus:ring-1 focus:ring-emerald-500 outline-none ${className}`}
          {...props}
        />
        {error && <span className="text-red-500 text-xs mt-1 block">{error}</span>}
      </div>
    );
  }
);

Input.displayName = 'Input';
